import React from 'react'
import PropTypes from 'prop-types'

import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'

import { map, sortBy } from 'lodash'

const riasecName = {
  R: 'Realistic',
  I: 'Investigative',
  A: 'Artistic',
  S: 'Sosial',
  E: 'Enterprising',
  C: 'Conventional',
}

const RiasecBox = ({ name, value, dominant }) => (
  <Col md="2">
    <div className="riasec-box">
      <div className="riasec-box__content">
        <span className="riasec-box__character">
          {name}: {riasecName[name]}
        </span>
        <span className="riasec-box__value">
          {Math.round(value)}
          <span>%</span>
        </span>
      </div>
    </div>
    <style jsx>
      {`
        .riasec-box {
          border-radius: 8px;
          border: solid 1px #d3dce6;
          background-color: #ffffff;
          padding: 16px 6px;
          &__content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
          }
          &__value {
            color: ${dominant ? '#00beff' : '#8fb0d4'};
          }
        }
      `}
    </style>
  </Col>
)

RiasecBox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.number,
  dominant: PropTypes.bool,
}

const RiasecBoxes = ({ ratio }) => {
  const mappedKey = map(ratio, (val, key) => ({
    key,
    val,
  }))
  const sortedKey = sortBy(mappedKey, 'val').map(val => val.key)
  const data = Object.entries(ratio).map(datum => [...datum, sortedKey.indexOf(datum[0]) > 2])

  return (
    <div className="riasec-boxes">
      <Row className="m-t-md" gapSize={8}>
        {
          data.map((datum, index) => (
            <RiasecBox
              key={`${index}-${datum[0]}`}
              name={datum[0]}
              value={datum[1]}
              dominant={datum[2]}
            />
          ))
        }
      </Row>

      <style jsx>
        {`
          .riasec-boxes {
            margin-bottom: 16px;
          }
        `}
      </style>
    </div>
  )
}


RiasecBoxes.propTypes = {
  ratio: PropTypes.object,
}

export { RiasecBox }

export default RiasecBoxes
